import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '@core/components/header/header.component';
import { SidebarComponent } from '@core/components/sidebar/sidebar.component';
import { INavigation } from '@core/interfaces/interface';
import { navigationClinic } from './navigation';

@Component({
  selector: 'app-clinic',
  standalone: true,
  imports: [RouterModule, HeaderComponent, SidebarComponent],
  templateUrl: './clinic.component.html',
  styleUrl: './clinic.component.scss',
})
export class ClinicComponent {
  public navigation: INavigation[] = navigationClinic;
}
